var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "settings" },
    [
      _c("div", { staticClass: "settings__item" }, [
        _vm.config.FEATURE_FLAGS.verification
          ? _c("div", { staticClass: "settings__item-header text_large" }, [
              _vm._v("\n      " + _vm._s(_vm.i18n.set_account()) + "\n    ")
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.config.FEATURE_FLAGS.verification
          ? _c(
              "div",
              { staticClass: "container container_30" },
              [
                _c(
                  "md-list",
                  [
                    _c(
                      "md-list-item",
                      { attrs: { to: "/verification" } },
                      [
                        _c(
                          "span",
                          { staticClass: "settings__item-text text_large" },
                          [_vm._v(_vm._s(_vm.i18n.set_verify_account()))]
                        ),
                        _vm._v(" "),
                        _c("md-icon", { staticClass: "md-icon--half-sized" }, [
                          _vm._v("keyboard_arrow_right")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "settings__item" }, [
        _c("div", { staticClass: "settings__item-header text_large" }, [
          _vm._v(_vm._s(_vm.i18n.set_security()))
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container container_30" },
          [
            _c(
              "md-list",
              [
                _c("change-password", {
                  staticClass: "security-settings__change-password"
                }),
                _vm._v(" "),
                _vm.tfaEnable
                  ? _c("md-divider", { staticClass: "md-dense" })
                  : _vm._e(),
                _vm._v(" "),
                _vm.tfaEnable
                  ? _c("tfa-settings", {
                      staticClass: "security-settings__tfa-settings",
                      attrs: {
                        "tfa-recovery-init": _vm.$route.params.tfaRecovery
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "settings__item" }, [
        _c("div", { staticClass: "settings__item-header text_large" }, [
          _vm._v(_vm._s(_vm.i18n.set_keys()))
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container container_30" },
          [
            _c(
              "md-list",
              [
                _c("account-id", {
                  staticClass: "security-settings__account-id"
                }),
                _vm._v(" "),
                _c("md-divider", { staticClass: "md-dense" }),
                _vm._v(" "),
                _c("seed", { staticClass: "security-settings__seed" })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "md-button",
        {
          staticClass: "btn btn_big md-primary",
          attrs: { type: "submit" },
          on: { click: _vm.toggleSignOut }
        },
        [
          _vm._v("\n    " + _vm._s(_vm.i18n.set_logout()) + "\n    "),
          _c("md-icon", { attrs: { "md-src": "/static/img/exit_app.svg" } })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "md-dialog",
        {
          attrs: { "md-active": _vm.view.mode },
          on: {
            "update:mdActive": function($event) {
              return _vm.$set(_vm.view, "mode", $event)
            },
            "update:md-active": function($event) {
              return _vm.$set(_vm.view, "mode", $event)
            }
          }
        },
        [
          _c("md-icon", {
            staticClass: "settings__logout-icon md-size-2x",
            attrs: { "md-src": "/static/img/log_out_app.svg" }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "text_large" }, [
            _vm._v(_vm._s(_vm.i18n.set_dialog_title()))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "settings__logout-text text_medium" }, [
            _vm._v(_vm._s(_vm.i18n.set_dialog_content()))
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "btn-wrap space-between margin-top" },
            [
              _c(
                "md-button",
                { staticClass: "btn md-primary", on: { click: _vm.signOut } },
                [_vm._v(_vm._s(_vm.i18n.set_bt_confirm()))]
              ),
              _vm._v(" "),
              _c(
                "md-button",
                {
                  staticClass: "btn md-primary",
                  on: { click: _vm.toggleSignOut }
                },
                [_vm._v(_vm._s(_vm.i18n.set_bt_cancel()))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c8be1670", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8be1670","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/settings/security/Settings.Security.vue
// module id = DLeY
// module chunks = 1